import ThemeChrono from '@/chrono/theme';
import { CHRONO, EBAT, MATERIAUX } from '@/common/constants';
import { useConfig } from '@/common/contexts/ConfigContext';
import ThemeEbat from '@/ebat/theme';
import ThemeMateriaux from '@/materiaux/theme';

const themes = {
  [EBAT]: ThemeEbat,
  [CHRONO]: ThemeChrono,
  [MATERIAUX]: ThemeMateriaux,
};

const useTheme = () => {
  const { env } = useConfig();

  return themes[env];
};

export default useTheme;
